import { render, staticRenderFns } from "./TabProposal.vue?vue&type=template&id=4f2810a8"
import script from "./TabProposal.vue?vue&type=script&lang=js"
export * from "./TabProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports